module.exports = flarum.core.compat['states/DiscussionListState'];